<template>
    <div>
        <a-form-model layout="inline" :model="searchForm">
            <a-form-model-item label="课程名称">
                <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.courseName"
                         placeholder="请输入课程名称"/>
            </a-form-model-item>
            <a-form-model-item label="课程类型">
                <a-select class="serach-item" allowClear v-model="searchForm.courseType" placeholder="请选择课程类型">
                    <a-select-option value="1">测评课程</a-select-option>
                    <a-select-option value="2">训练课程</a-select-option>
                    <a-select-option value="3">活动课程</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item style="margin-right: 35px;">
                <a-button @click="getPageList(1)" type="primary" html-type="button">
                    查询
                </a-button>
                <a-button @click="searchReset" style="margin-left: 10px;">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <a-table style="min-width: 800px;"
                 :columns="columns"
                 rowKey="id"
                 :scroll="{y: 350}"
                 :row-selection="rowSelection"
                 :pagination="tableRelevant.tablePagination"
                 :loading="tableRelevant.tableLoading"
                 :locale="tableRelevant.locale"
                 :dataSource="tableRelevant.tableDataSource">
            <div class="course-name" :title="text.name" slot="icon" slot-scope="text, record">
                <img :src="text.icon | filterUrl" alt="">
                <span>{{ text.name }}</span>
            </div>
            <div slot="age" slot-scope="text, record">
                {{record.minAge + '~' + record.maxAge}}岁
            </div>
            <div slot="type" slot-scope="text, record">
                <span v-if="record.courseType === 1">测评课程</span>
                <span v-else>训练课程</span>
            </div>
        </a-table>
    </div>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const columns = [
        {title: "课程名称", scopedSlots: {customRender: "icon"}},
        {title: "备注", dataIndex: "remark"},
        {title: "课时数量", dataIndex: "courseSessionCount"},
        {title: "适配年龄", scopedSlots: {customRender: "age"}},
        {title: "课程类型", scopedSlots: {customRender: "type"}},
        {title: "报告数量", dataIndex: "reportCount"}
    ];

    export default {
        name: "ImportCourse",
        data() {
            return {
                searchForm: {
                  courseName: undefined,
                    courseType: undefined,
                },
                columns,
                //表格相关
                tableRelevant: tableRelevant.call(this),
                selectedRowKeys: []
            }
        },
        computed: {
            rowSelection() {
                return {
                    selectedRowKeys: this.selectedRowKeys,
                    onChange: (selectedRowKeys, selectedRows) => {
                        this.selectedRowKeys = selectedRowKeys;
                    }
                };
            },
        },
        mounted() {
            this.getPageList(1);
        },
        methods: {
            getPageList(page) {
                const params = {
                    pageIndex: page || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    ...this.searchForm
                };
                this.tableRelevant.tableLoading = true;
                this.$http.CourseResource.courseList(params).then(res => {
                    const {status, data, message} = res;
                  this.tableRelevant.tableDataSource = data.items;
                  this.tableRelevant.tablePagination.total = data.totalCount;
                  this.tableRelevant.tablePagination.current = data.pageIndex;
                }).finally(() => {
                  this.tableRelevant.tableLoading = false;
                })
            },
            searchReset() {
                this.searchForm = {
                    courseName: undefined,
                    courseType: undefined
                };
                this.getPageList(1);
            }
        }
    }
</script>

<style scoped>
    .course-name {
        display: flex;
        align-items: center;
    }
    .course-name span{
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        flex-grow: 2;
    }

    .course-name img {
        width: 25px;
        height: 25px;
        object-fit: contain;
        margin-right: 5px;
        flex-shrink: 0;
    }
</style>
